interface CounterProps {
  count: number;
  increment: () => void;
  decrement: () => void;
}

const Counter = ({ count, decrement, increment }: CounterProps) => {
  return (
    <div className="flex items-center border border-neutral-20 rounded-xl w-32 justify-between px-2">
      <button
        onClick={decrement}
        className="w-10 flex items-center justify-center border-neutral-30 text-neutral-50 text-4xl hover:bg-gray-100 rounded-xl focus:outline-none"
      >
        −
      </button>
      <div className="text-lg font-semibold  border-neutral-20">{count}</div>
      <button
        onClick={increment}
        className="w-10  flex items-center justify-center text-primary-50 text-4xl hover:bg-blue-100 rounded-xl focus:outline-none"
      >
        +
      </button>
    </div>
  );
};

export default Counter;
